import { freeze }        from 'rewire-core';
import {
  Modal,
  Form,
  IFormContext,
  field,
  error,
  validator,
}                        from 'rewire-ui';
import { passwordRegEx } from '../DataTypes';
import DataMutations     from '../graphql/Mutations';
import { notifications } from '../ui/Notifications';

interface IResetPasswordModelState {
  token:      string;
  isComplete: boolean;
}

export class ResetPasswordModel extends Modal<IResetPasswordModelState> {
  form: Form;

  constructor() {
    super('', true);
    this.form = Form.create((form: IFormContext) => ({
      email:              form.email().label('Email').validators('required').placeholder('enter your email').autoFocus(), // temporary while we figure out how to include user identification in the sent email
      newPassword:        form.password().label('New Password').validators('required', passwordRegEx, validator('==', field('confirmNewPassword'), error('passwords are not the same'))).placeholder('enter your new password'),
      confirmNewPassword: form.password().label('Confirm New Password').validators('required').placeholder('enter confirm new password'),
    }),
    {},
    { validateOnUpdate: false });
    this.action('submit', this.submit, {type: 'submit'});
  }

  reset() {
    this.form.reset();
    freeze(() => {
      this.state.isComplete = false;
      this.state.token      = '';
    });
  }

  load(token: string) {
    this.reset();
    this.state.token = token;
  }

  get token(): string {
    return this.state.token;
  }

  get isComplete(): boolean {
    return this.state.isComplete;
  }

  private resetPassword = async (): Promise<boolean> => {
    // const result = await DataMutations.confirmForgotPassword(this.token, this.email, this.form.field.newPassword.value);
    const result = await DataMutations.confirmForgotPassword(this.token, this.form.field.email.value, this.form.field.newPassword.value);
    if (result) {
      notifications.success('Reset Password Successful');
      this.state.isComplete = true;
      return true;
    }
    notifications.error('Reset Password Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.resetPassword);
  };
}

const resetPasswordModel = new ResetPasswordModel();
export default resetPasswordModel;
